// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Product Catalogue API
 * Endpoints for querying product catalogue data including products and their versions.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Version } from './Version';
import {
  VersionFromJSON,
  VersionFromJSONTyped,
  VersionToJSON,
  VersionToJSONTyped,
} from './Version';

/**
 *
 * @export
 * @interface GetAllVersionsResponse
 */
export interface GetAllVersionsResponse {
  /**
   *
   * @type {Array<Version>}
   * @memberof GetAllVersionsResponse
   */
  data: Array<Version>;
}

/**
 * Check if a given object implements the GetAllVersionsResponse interface.
 */
export function instanceOfGetAllVersionsResponse(
  value: object,
): value is GetAllVersionsResponse {
  if (!('data' in value) || value['data'] === undefined) return false;
  return true;
}

export function GetAllVersionsResponseFromJSON(
  json: any,
): GetAllVersionsResponse {
  return GetAllVersionsResponseFromJSONTyped(json, false);
}

export function GetAllVersionsResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): GetAllVersionsResponse {
  if (json == null) {
    return json;
  }
  return {
    data: (json['data'] as Array<any>).map(VersionFromJSON),
  };
}

export function GetAllVersionsResponseToJSON(
  json: any,
): GetAllVersionsResponse {
  return GetAllVersionsResponseToJSONTyped(json, false);
}

export function GetAllVersionsResponseToJSONTyped(
  value?: GetAllVersionsResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    data: (value['data'] as Array<any>).map(VersionToJSON),
  };
}
